import React, { useState, useMemo } from 'react'
import Link from 'next/link'

interface Props {
  posts: any
}

interface Post {
  title: {
    rendered: string
  }
  slug: string
  featuredImg: {
    thumbnail: string
  }
}

function PostPreview({ post }: { post: Post }) {
  return (
    <div className="flex items-center">
      <img className="w-12 rounded-md mr-4" src={post.featuredImg.thumbnail} />
      <Link href={`/blog/${post.slug}`}>
        <a className="text-sm leading-tight hover:underline hover:text-brand">
          {post.title.rendered}
        </a>
      </Link>
    </div>
  )
}

export default function Related({ posts }: Props) {
  const [view, setView] = useState<'recent' | 'popular'>('recent')
  const recentPosts: Post[] = useMemo(() => {
    return posts.slice(0, 4)
  }, [posts])
  const popularPosts: Post[] = useMemo(() => {
    return posts.reverse().slice(0, 4)
  }, [posts])

  return (
    <div>
      <div className="flex mb-4 cursor-pointer gap-4">
        <button
          className={`text-xl ${view === 'recent' ? 'font-black' : ''}`}
          onClick={() => setView('recent')}
        >
          Recent
        </button>
        <button
          className={`text-xl ${view === 'popular' ? 'font-black' : ''}`}
          onClick={() => setView('popular')}
        >
          Popular
        </button>
      </div>
      <div className="flex flex-col gap-2">
        {view === 'recent' &&
          recentPosts.map(post => <PostPreview key={post.slug} post={post} />)}
        {view === 'popular' &&
          popularPosts.map(post => <PostPreview key={post.slug} post={post} />)}
      </div>
    </div>
  )
}
